import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { ApolloLink } from 'apollo-link';
import { Store } from 'redux';
import { SELF_SERVICE_API_URL } from 'config';
import { setRequestHeaders, errorLink } from './helpers';
import { fragmentMatcher } from './fragmentMatcher';

export const createClient = (store: Store) => {
  const headersLink = new ApolloLink(setRequestHeaders(store));

  const httpLink = new HttpLink({
    uri: `${SELF_SERVICE_API_URL}/graphql`,
    credentials: 'include',
    // fetchOptions: {
    //   credentials: 'include',
    // },
  });

  // Retry when http status is not 200
  const retryLink = new RetryLink({
    delay: {
      initial: 300,
      max: 1500,
      jitter: false,
    },
    attempts: {
      max: 15,
    },
  });

  return new ApolloClient({
    cache: new InMemoryCache({ fragmentMatcher }),
    link: ApolloLink.from([errorLink, retryLink, headersLink, httpLink]),
  });
};
